module.exports = __webpack_public_path__ + "assets/img/shashou.1dc6ad9f.png";